import React from "react";
import Meta from "./../components/Meta";
import FaucetBox from "../components/FaucetBox";

function FaucetPage(props) {
    return (
        <>
        <br>
        </br>
        <Meta title="Faucet" />
        <FaucetBox
            color="primary"
            size="medium"
            backgroundImage=""
            backgroundImageOpacity={1}
            title=""
            subtitle=""
            buttonText=""
            buttonColor="primary"
            buttonInverted={false}
            showNameField={true}
            />
        </>
    );
}

export default FaucetPage;